import { Tracking } from './../providers/tracking';
import { ModelMetier } from './../providers/model-metier';
import { ToastMessage } from './../providers/toast-message';
import { AuthData } from './../providers/auth-data';
import { HomePage } from './../pages/home/home';
import { DebugPage } from './../pages/debug/debug';
import { UsersPage } from './../pages/users/users';
import { Component, ViewChild, NgZone } from '@angular/core';
import { Platform, Nav, LoadingController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { Login } from '../pages/login/login';

import { Storage } from '@ionic/storage';
import firebase from 'firebase';



@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  
  @ViewChild(Nav) 
  navCtrl: Nav;

  keyLastPage = "lastPage";
  //
  rootPage:HomePage;

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen,
              public authData: AuthData, public toastMessage : ToastMessage, private zone: NgZone,
              public loadingCtrl: LoadingController, private storage: Storage,
              public tracking : Tracking,
              public modelMetier: ModelMetier ) {




    // Last Page
    this.storage.get(this.keyLastPage).then((val) => {
      console.log('lastPage', val);
      // if (val) this.rootPage = val;
    });

    this.authData.onAuthStateChanged( ()=> { 
          
      if (!this.authData.getUser()) {
        this.goToLogin();
        return;
      }
this.goToHome();
// this.goToUsers();
    });


    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
        
    });

  }


  setRootPage(page) : Promise<any> {
    
    return this.zone.run( ()=>{

    let pageName = page.name;
// console.log("Class name: " + pageName);
// let fct = window[pageName];
// console.log("fct Class name: " + fct);


      this.storage.set(this.keyLastPage, pageName);
      return this.navCtrl.setRoot(page);
    });
  }

  goToLogin() : Promise<any> {
    return this.setRootPage(Login);
  }

  goToHome() : Promise<any> {
    return this.setRootPage(HomePage);
  }

  goToUsers() : Promise<any> {
    return this.setRootPage(UsersPage);
  }


  doRefreshDb() {



    let loaderContentBase = "Start refresh from licIdTagValue,<p>Please wait...";
    let loader = this.loadingCtrl.create({
      content: loaderContentBase,
    });
    loader.present();

    // this.toastMessage.message('Start refresh from licIdTagValue, please wait');



    this.modelMetier.analyseAllDbStorage( (progress) => { 

      console.log("analyseAllDbStorage " + progress);

      this.zone.run(() => {
	      let str = loaderContentBase + "<p>" + progress.toFixed(0) + "%";
        loader.setContent(str);
	    });
  
    }).then( () => {

       loader.dismiss();
      this.toastMessage.success('Refresh from licIdTagValue finish.');

    }).catch((err) => {
      loader.dismiss();

      this.toastMessage.error('Refresh from licIdTagValue error: ' + err);

    });
  }
//@TODO ETA   nb minutes, les than 1 minute, 
// https://github.com/titarenko/eta 

  goToDebug() {
    this.navCtrl.push(DebugPage);
  }


  doLogout() {

    this.goToLogin().then( () => {
      this.authData.logoutUser();
    });


    // this.authData.logoutUser().then(() => {
    //     this.navCtrl.setRoot(Login);
    // });
  }


}




// WEBPACK FOOTER //
// ./src/app/app.component.ts